




















import { Vue, Component, Prop } from 'vue-property-decorator'
import { select } from 'components/modals/Number.vue'

@Component
export default class ItemCourseGradebookSettingsButtonWeight extends Vue {

  @Prop()
  readonly value!: number | null

  @Prop()
  readonly total!: number

  get percent () {
    return 100 * (this.value || 0) / Math.max(1, this.total)
  }

  get percentFraction () {
    return (this.percent * 10) % 10
  }

  async action () {
    const value = await select(this, {
      title: this.$t('item.course.gradebook.weight.title').toString(),
      btnMiddle: this.$t('label.clear').toString(),
      value: this.value,
      min: 0,
      max: 100,
      slider: true,
      formatter: (value: number) => {
        const percent = 100 * value / Math.max(1, (this.total - (this.value || 0)) + value)
        return `${value}\n${(percent || 0).toFixed(1)}%`
      }
    })
    this.$emit('input', value || null)
  }
}
